<template>
  <v-text-field
    v-model="modelValue"
    outlined
    dense
    hide-details="auto"
    :disabled="disabled"
    :label="label"
    :placeholder="placeholder"
    :persistent-placeholder="!!placeholder"
    :rules="rules"
    :append-icon="appendIcon"
    :type="computedType"
    :hint="hint"
    :persistent-hint="!!hint"
    :suffix="suffix"
    :min="min"
    :max="max"
    v-mask="mask"
  />
</template>

<script>
import { PropOptions, ComputedOptions } from 'vue'
import { Computed } from '@/_typedefs'
import { mask } from 'vue-the-mask'

export default {
  name: 'SimpleTextInputComponent',
  props: {
    value: {
      type: [String, Number],
      validator: (v) => ['string', 'number'].includes(typeof v) || v === null,
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    appendIcon: {
      type: String,
      default: null,
    },
    /** @type {PropOptions<'text' | 'number' | 'tel'>} */
    type: {
      type: String,
      default: 'text',
      validator: (v) => ['text', 'number', 'tel'].includes(v),
    },
    /** @type {PropOptions<Array<(v: any) => boolean | string>>} */
    rules: {
      type: Array,
      default: () => [],
    },
    /** @type {PropOptions<string | string[]>} */
    mask: {
      type: [Array, String],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: null,
    },
    suffix: {
      type: String,
      default: null,
    },
    max: {
      type: [Number, String],
      default: null,
    },
    min: {
      type: [Number, String],
      default: null,
    },
  },
  directives: {
    mask: {
      bind(el, binding, vnode, oldVnode) {
        if (binding.value) {
          mask(el, binding, vnode, oldVnode)
        }
      },
    },
  },
  computed: {
    /** @type {ComputedOptions<string | number>} */
    modelValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    /** @type {Computed<'text' | 'number' | 'tel'>} */
    computedType() {
      if (this.type === 'number' && !!this.mask) {
        return 'tel'
      }
      return this.type
    },
  },
}
</script>

<style scoped>
:deep(.v-input__slot) {
  min-height: 48px !important;
  font-size: 14px;
}

:deep(.v-text-field__details) {
  margin: 0 !important;
}

/* Chrome, Safari, Edge, Opera */
:deep(input::-webkit-outer-spin-button),
:deep(input::-webkit-inner-spin-button) {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
:deep(input[type='number']) {
  -moz-appearance: textfield;
  appearance: textfield;
}
</style>
